import { ApolloError } from "@apollo/client";

interface IProps {
  error: ApolloError;
}

export default function Error({ error }: IProps) {
  return (
    <div>
      <p>An error has occurred!</p>
      <pre>{JSON.stringify(error, null, 2)}</pre>
    </div>
  );
}
